/** Canonical role strings as they arrive on the wire (no "ROLE_" prefix). */
export const ADMIN_ROLE = 'ADMIN';

/**
 * Exact-match role check. Deliberately NOT a substring match like
 * `resolveBillingTier` — an authority decision must not match "ADMINISTRATIVE"
 * or "ROLE_ADMIN" by accident. Null/undefined-safe for older persisted sessions.
 */
export function hasRole(roles: string[] | null | undefined, role: string): boolean {
  return (roles ?? []).includes(role);
}

export function isAdmin(roles: string[] | null | undefined): boolean {
  return hasRole(roles, ADMIN_ROLE);
}
